import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=ae2169a8"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports